import { useEffect } from 'react';

export function useScrollLock(active: boolean) {
	useEffect(() => {
		if (!active) return;

		const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

		const originalBodyOverflow = document.body.style.overflow;
		const originalDocumentOverflow = document.documentElement.style.overflow;
		const originalPaddingRight = document.body.style.paddingRight;

		document.body.style.overflow = 'hidden';
		document.documentElement.style.overflow = 'hidden';
		document.body.style.paddingRight = `${scrollbarWidth}px`;

		return () => {
			document.body.style.overflow = originalBodyOverflow;
			document.documentElement.style.overflow = originalDocumentOverflow;
			document.body.style.paddingRight = originalPaddingRight;
		};
	}, [active]);
}
